import { InjectionToken } from "@angular/core";

export const PRODUCT_CODE = new InjectionToken("PRODUCT_CODE");
